import httpClient from '../../client'

import apiRoutes from '../constants'

const createCustomer = async (body) => {
  try {
    const {data} = await httpClient.post(`${apiRoutes.POST_CUSTOMERS}`, {...body})
    if (data) {
      return data
    }
    throw data
  } catch (error) {
    throw Error(error.response.data.message)
  }
}

export default createCustomer
